@import 'styles/mixins';
@import 'styles/variables';

.card {
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-5);
    [data-design-system='blaze'] & {
      background-color: rgba(255, 255, 255, 0.74);
    }
  }
}
